export const Placeholder = () => (
  <svg width="500" height="400" viewBox="0 0 500 400" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h500v400H0z" />
      <path fill="#E4E6F2" fillRule="nonzero" d="M38 118h424v8H38zm0 22h424v8H38zm0 22h384v8H38z" />
      <path fill="#E4E6F2" d="M38 34h82v8H38z" />
      <path d="M37.5 77.5H463" stroke="#E4E6F2" strokeLinecap="square" />
    </g>
  </svg>
)
